import { render, staticRenderFns } from "./setwallet.vue?vue&type=template&id=6cb68a70&scoped=true&"
import script from "./setwallet.vue?vue&type=script&lang=js&"
export * from "./setwallet.vue?vue&type=script&lang=js&"
import style0 from "./setwallet.vue?vue&type=style&index=0&id=6cb68a70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb68a70",
  null
  
)

export default component.exports